/** Read-only Kontaktmöglichkeiten inside Kontaktdaten (PersonData) on the person view page. */
function initContactOptionsViewSection() {
  const currentContactId =
    window.location.pathname.match(/\/persons\/view-person\/(\d+)/)?.[1] ||
    window.location.pathname.match(/\/view-person\/(\d+)/)?.[1]
  if (!currentContactId) {
    return false
  }

  const personData = document.querySelector('.PersonData')
  if (!personData) {
    return false
  }

  const cache =
    window.__luxContactOptionsViewCache || (window.__luxContactOptionsViewCache = {})

  const existingSection = document.querySelector('[data-impowerx-view-contact-options="true"]')
  if (existingSection) {
    if (existingSection._contactId === currentContactId && document.body.contains(existingSection)) {
      return true
    }
    existingSection.remove()
  }

  const TYPE_LABELS = {
    email: 'E-Mail',
    tel: 'Telefon',
  }

  const section = document.createElement('div')
  section.className = 'impowerx-contact-options-view'
  section.dataset.impowerxViewContactOptions = 'true'
  section._contactId = currentContactId
  section.innerHTML = `
    <style data-field-name="viewContactOptionsStyle">
      .impowerx-contact-options-view {
        margin-top: 16px;
        width: 100%;
      }
      .impowerx-contact-options-view-heading {
        font-size: 12px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.45);
        text-transform: uppercase;
        margin-bottom: 8px;
      }
      .impowerx-contact-options-view-content {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .impowerx-contact-options-view-row {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        row-gap: 6px;
      }
      .impowerx-contact-options-view-item {
        box-sizing: border-box;
        flex: 0 0 calc((100% - 32px) / 3);
        max-width: calc((100% - 32px) / 3);
        min-width: 8rem;
      }
      .impowerx-contact-options-view-value {
        word-break: break-word;
      }
    </style>
    <div class="impowerx-contact-options-view-heading">Weitere Kontaktmöglichkeiten</div>
    <div class="impowerx-contact-options-view-content" data-field-name="contactOptionsViewContent">
      <div class="basic-info section">
        <div class="value">Lade...</div>
      </div>
    </div>
  `

  personData.appendChild(section)

  const contentEl = section.querySelector('[data-field-name="contactOptionsViewContent"]')

  const renderItems = (items) => {
    contentEl.innerHTML = ''
    items.forEach((item) => {
      const row = document.createElement('div')
      row.className = 'impowerx-contact-options-view-row'

      const fields = [
        { label: 'Titel', value: item.title || '—' },
        { label: 'Typ', value: TYPE_LABELS[item.type] || item.type || '—' },
        { label: 'Wert', value: item.value || '—' },
      ]

      fields.forEach(({ label, value }) => {
        const field = document.createElement('div')
        field.className = 'basic-info section impowerx-contact-options-view-item'
        const labelEl = document.createElement('div')
        labelEl.className = 'label'
        labelEl.textContent = label
        const valueEl = document.createElement('div')
        valueEl.className = 'value impowerx-contact-options-view-value'
        valueEl.textContent = value
        field.append(labelEl, valueEl)
        row.appendChild(field)
      })

      contentEl.appendChild(row)
    })
  }

  const renderMessage = (message) => {
    contentEl.innerHTML = ''
    const wrap = document.createElement('div')
    wrap.className = 'basic-info section'
    const valueEl = document.createElement('div')
    valueEl.className = 'value'
    valueEl.textContent = message
    wrap.appendChild(valueEl)
    contentEl.appendChild(wrap)
  }

  const applyCachedOrEmpty = (cached) => {
    if (!cached) return false
    if (cached.empty) {
      section.style.display = 'none'
      section._empty = true
      return true
    }
    if (Array.isArray(cached.items)) {
      if (cached.items.length === 0) {
        section.style.display = 'none'
        section._empty = true
      } else {
        renderItems(cached.items)
      }
      return true
    }
    return false
  }

  // Remount after SPA paint: restore from cache (no "Lade..." flash / refetch)
  if (applyCachedOrEmpty(cache[currentContactId])) {
    return true
  }

  ;(async () => {
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || '{}')
      const token = authData.token
      if (!token) {
        if (document.body.contains(section)) {
          renderMessage('Nicht verfügbar')
        }
        return
      }

      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/contact-options?contactId=${currentContactId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )

      if (!document.body.contains(section) || section._contactId !== currentContactId) {
        return
      }

      if (!res.ok) {
        renderMessage('Fehler beim Laden')
        return
      }

      const data = await res.json()
      const items = Array.isArray(data?.items) ? data.items : []

      if (items.length === 0) {
        // Keep a hidden sentinel so MutationObserver does not remount/refetch.
        cache[currentContactId] = { empty: true, items: [] }
        section.style.display = 'none'
        section._empty = true
        return
      }

      cache[currentContactId] = { items }
      renderItems(items)
    } catch (error) {
      if (document.body.contains(section) && section._contactId === currentContactId) {
        renderMessage('Fehler beim Laden')
      }
    }
  })()

  return true
}
